import { render } from "./MyNotificationsMenu.vue?vue&type=template&id=d7f1d04e"
import script from "./MyNotificationsMenu.vue?vue&type=script&lang=ts"
export * from "./MyNotificationsMenu.vue?vue&type=script&lang=ts"

import "./MyNotificationsMenu.vue?vue&type=style&index=0&id=d7f1d04e&lang=scss"
script.render = render

export default script